export default __webpack_public_path__ + "static/media/TERMINAL_ICON_07.8ef348f3.svg";